import React from 'react';

import ListView from './ListView';

function List(props) {
  return <ListView {...props} />;
}

export default List;
